import qs from "qs";
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class AuditLog extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "audit-log";
    static pluralName = "audit-logs";

    constructor() {
        super(AuditLog.kind, AuditLog.singularName, AuditLog.pluralName);
    }

    async getAll(query = {}) {
        return this.fetch(qs.stringify(query, {encodeValuesOnly: true}));
    }
}
